import React from 'react';
import AdminOverview from '@/components/admin/AdminOverview';
import { useOptimizedAdminData } from '@/hooks/useOptimizedAdminData';
import { useAdminPendingActivities } from '@/hooks/useAdminPendingActivities';
import { useAdminFilter } from '@/contexts/AdminFilterContext';

const AdminOverviewPage = () => {
  const { userTypeFilter } = useAdminFilter();

  const adminData = useOptimizedAdminData({ userTypeFilter });
  const { data: pendingActivities, isLoading: loadingActivities } = useAdminPendingActivities();

  return (
    <AdminOverview 
      {...adminData} 
      pendingActivities={pendingActivities || {
        waiting_verifications: 0,
        pending_verifications: 0,
        pending_tickets: 0,
        total_pending: 0,
      }}
      loadingActivities={loadingActivities}
    />
  );
};

export default AdminOverviewPage;
